import React from 'react';
import kidneyImage from '../assets/kidney.jpeg';

const About = () => {
  const isMobile = window.innerWidth <= 768;

  return (
    <div className="section">
      <div className="container" style={{ maxWidth: '1000px', margin: '0 auto' }}>
        <h1 className="section-title text-dark-green" style={{ textAlign: 'center', marginBottom: '2rem' }}>
          About NAUS
        </h1>

        {/* Desktop: Image left, text right | Mobile: Image centered above text */}
        {isMobile ? (
          <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
            <img
              src={kidneyImage}
              alt="Kidney Illustration"
              style={{
                width: '120px',
                height: '120px',
                borderRadius: '50%',
                marginBottom: '1.5rem',
              }}
            />
          </div>
        ) : (
          <div style={{ display: 'flex', gap: '2rem', alignItems: 'flex-start', marginBottom: '2rem' }}>
            <div style={{ flexShrink: 0 }}>
              <img
                src={kidneyImage}
                alt="Kidney Illustration"
                style={{
                  width: '150px',
                  height: '150px',
                  borderRadius: '50%',
                  boxShadow: '0 4px 10px rgba(0, 100, 0, 0.2)',
                }}
              />
            </div>
            <div></div> {/* Empty spacer to keep layout clean */}
          </div>
        )}

        <div style={{ textAlign: isMobile ? 'center' : 'left' }}>
          <div style={{ textAlign: 'left' }}>
          

            <h2 style={{ color: 'var(--primary-teal)', marginTop: '2rem', marginBottom: '1rem' }}>
              EXECUTIVE COMMITTEE
            </h2>
            <ol style={{ paddingLeft: '1.5rem' }}>
              <li>Dr. Augustine O. Takure – President</li>
              <li>Prof. Ngozi O. Ekeke _ President Elect</li>
              <li>Prof. Nuhu.K. Dakum – Ex. Officio I</li>
              <li>Prof. Samaila I. Shuaibu – Secretary General</li>
              <li>Prof. John E. Raphael – Assistant Secretary General</li>
              <li>Prof. Timothy U. Mbaeri – Treasurer</li>
              <li>Prof. I.I. Nnabugwu _ Financial Secretary</li>
              <li>Prof. Atim Terkaa _ PRO</li>
              <li>Prof. Muhammed Ahmed – Editor-in-Chief, NJU</li>
            </ol>

            <h2 style={{ color: 'var(--primary-teal)', marginTop: '2rem', marginBottom: '1rem' }}>
              STANDING COMMITTEES CHAIRMEN
            </h2>
            <ol style={{ paddingLeft: '1.5rem' }}>
              <li>Prof. Chidi K. Oranusi – Workshop Committee</li>
              <li>Prof. Sani A. Aji – Welfare Committee</li>
              <li>Dr. Abubakar S. Muhamamd – Chairman CME Committee</li>
            </ol>

            <h2 style={{ color: 'var(--primary-teal)', marginTop: '2rem', marginBottom: '1rem' }}>
              HISTORY OF THE ASSOCIATION OF UROLOGICAL SURGEONS, NIGERIA (NAUS)
            </h2>
            <p>
              The cradle of the Association of Urological Surgeons, Nigeria (NAUS), previously named Nigerian Association of Urological Surgeons (NAUS) was the Nnamdi Azikiwe University Teaching Hospital, Nnewi, where an inaugural meeting was held on Thursday, 3rd December, 1992. The holding of the meeting was facilitated by Prof. O.O. Mbonu and Dr A.E Aghaji, and was sponsored by Prof. Mbonu who was then the Chief Medical Director of the Nnamdi Azikiwe University Teaching Hospital. The meeting had 10 Urologists in attendance and Prof. O.O Mbonu and Dr A.E Aghaji were elected Protem President and Protem Secretary respectively.
            </p>
            <p>
              Actions were put in motion to grow and stabilize the fledging association. In 1994, another meeting was held at the Department of Surgery of the Lagos University Teaching Hospital, sponsored by Dr D. N. Osegbe. At the meeting, a constitution for the association produced by the protem executive committee was adopted. As required by the constitution, the following substantive officers were elected to run the affairs of the association:
            </p>
            <ul>
              <li>Prof. O.O. Mbonu - President</li>
              <li>Dr D. N. Osegbe - Vice President</li>
              <li>Dr A.E. Aghaji - Secretary-General</li>
              <li>Dr J.C Orakwe - Treasurer/Financial Secretary</li>
            </ul>
            <p>
              These were the first substantive officers of the association. Subsequently, the Presidents and Secretary-Generals of the association since inception have been:
            </p>
            <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '1rem' }}>
              <thead>
                <tr>
                  <th style={{ border: '1px solid #ccc', padding: '0.5rem' }}>PERIOD</th>
                  <th style={{ border: '1px solid #ccc', padding: '0.5rem' }}>PRESIDENT</th>
                  <th style={{ border: '1px solid #ccc', padding: '0.5rem' }}>SECRETARY-GENERAL</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ border: '1px solid #ccc', padding: '0.5rem' }}>1992–1998</td>
                  <td style={{ border: '1px solid #ccc', padding: '0.5rem' }}>Prof O. O. Mbonu</td>
                  <td style={{ border: '1px solid #ccc', padding: '0.5rem' }}>Dr A. E. Aghaji</td>
                </tr>
                <tr>
                  <td style={{ border: '1px solid #ccc', padding: '0.5rem' }}>1998–2005</td>
                  <td style={{ border: '1px solid #ccc', padding: '0.5rem' }}>Prof. D. N. Osegbe</td>
                  <td style={{ border: '1px solid #ccc', padding: '0.5rem' }}>Prof. A. E. Aghaji</td>
                </tr>
                <tr>
                  <td style={{ border: '1px solid #ccc', padding: '0.5rem' }}>2005–2009</td>
                  <td style={{ border: '1px solid #ccc', padding: '0.5rem' }}>Prof. A. E Aghaji</td>
                  <td style={{ border: '1px solid #ccc', padding: '0.5rem' }}>Prof. A. M. E. Nwofor</td>
                </tr>
                <tr>
                  <td style={{ border: '1px solid #ccc', padding: '0.5rem' }}>2009–2013</td>
                  <td style={{ border: '1px solid #ccc', padding: '0.5rem' }}>Prof A. M. E. Nwofor</td>
                  <td style={{ border: '1px solid #ccc', padding: '0.5rem' }}>Dr. C. N. Amaechina</td>
                </tr>
                <tr>
                  <td style={{ border: '1px solid #ccc', padding: '0.5rem' }}>2013–2015</td>
                  <td style={{ border: '1px solid #ccc', padding: '0.5rem' }}>Prof J. C. Orakwe</td>
                  <td style={{ border: '1px solid #ccc', padding: '0.5rem' }}>Prof N. K. Dakum</td>
                </tr>
                <tr>
                  <td style={{ border: '1px solid #ccc', padding: '0.5rem' }}>2015–2017</td>
                  <td style={{ border: '1px solid #ccc', padding: '0.5rem' }}>Dr. E.A. Jeje</td>
                  <td style={{ border: '1px solid #ccc', padding: '0.5rem' }}>Prof N. K. Dakum</td>
                </tr>
                <tr>
                  <td style={{ border: '1px solid #ccc', padding: '0.5rem' }}>2017–2019</td>
                  <td style={{ border: '1px solid #ccc', padding: '0.5rem' }}>Prof. V. M. Ramyil</td>
                  <td style={{ border: '1px solid #ccc', padding: '0.5rem' }}>Dr. A. O. Takure</td>
                </tr>
                <tr>
                  <td style={{ border: '1px solid #ccc', padding: '0.5rem' }}>2019–2021</td>
                  <td style={{ border: '1px solid #ccc', padding: '0.5rem' }}>Dr. E. U. Azodoh</td>
                  <td style={{ border: '1px solid #ccc', padding: '0.5rem' }}>Dr. A. O. Takure</td>
                </tr>
                <tr>
                  <td style={{ border: '1px solid #ccc', padding: '0.5rem' }}>2021–2023</td>
                  <td style={{ border: '1px solid #ccc', padding: '0.5rem' }}>Prof. Ndubuisi Eke</td>
                  <td style={{ border: '1px solid #ccc', padding: '0.5rem' }}>Prof M. Ahmed</td>
                </tr>
                <tr>
                  <td style={{ border: '1px solid #ccc', padding: '0.5rem' }}>2023–2025</td>
                  <td style={{ border: '1px solid #ccc', padding: '0.5rem' }}>Prof. Nuhu K Dakum</td>
                  <td style={{ border: '1px solid #ccc', padding: '0.5rem' }}>Prof M. Ahmed</td>
                </tr>
              </tbody>
            </table>

            <p style={{ marginTop: '1.5rem' }}>
              The 3rd meeting of the Association held at Jos in 1997 and incorporated a scientific session. This was the first scientific meeting of the association. Subsequently, Annual General Meetings and Scientific Conferences have been held as follows:
            </p>
            <ul>
              <li>4th-1998 – Lagos</li>
              <li>5th-1999 – Port Harcourt</li>
              <li>6th-2000 – Abraka</li>
              <li>7th-2001 – Abuja</li>
              <li>8th-2002 – Nnewi</li>
              <li>9th-2003 – Abuja (PAUSA)</li>
              <li>10th-2004 – Ibadan</li>
              <li>11th-2005 – Lagos</li>
              <li>12th-2006 – Calabar</li>
              <li>13th-2007 – Jos</li>
              <li>14th-2008 – Ilorin</li>
              <li>15th-2009 – Enugu</li>
              <li>16th-2010 – Kano</li>
              <li>17th-2011 – Abuja</li>
              <li>18th-2012 – Port Harcourt</li>
              <li>19th-2013 – Ibadan</li>
              <li>20th-2014 – Lagos</li>
              <li>21st-2015 – Zaria</li>
              <li>22nd-2016 – Calabar</li>
              <li>23rd-2017 – Benin</li>
              <li>24th-2018 – Sokoto</li>
              <li>25th-2019 – Ilorin</li>
              <li>26th-2020 – Did not hold due to the Corona Virus pandemic</li>
              <li>26th-2021 – Abuja</li>
              <li>27th-2022 – Port Harcourt</li>
              <li>28th-2023 – Jos</li>
              <li>29th-2024 – Enugu</li>
              <li>25th-2025 – Lagos</li>
            </ul>
            <p>
              NAUS hosted the 2003 biennial Conference of the Pan African Association of Urological Surgeon (PAUSA) which held in Abuja. That PAUSA Conference subsumed the NAUS meeting of that year in Abuja.
            </p>

            <h3 style={{ marginTop: '1.5rem', marginBottom: '1rem' }}>NAUS Workshops</h3>
            <p>
              The organisation of NAUS Workshops commenced in 2007 and it started as a Pre-Conference Workshop at the Jos conference of that year. Subsequently, the annual conferences have been preceded by a pre-conference workshop. The Instrument giant, The Karl-Storz of Germany, has been very supportive of this venture and has contributed immensely in making the workshops robust and inspiring. In 2011, still in collaboration with Karl-Storz, the “Endourology Roadshow” was started. Thus, in addition to the pre-conference workshops, NAUS-Karl Storz Urology Workshops (Endourology Roadshows) were held as quarterly events, rotating through all the geopolitical zones of the country. These workshops, elegantly coordinated by Prof V. M. Ramyil and Dr. E. U. Azodoh since inception, have helped in no small measure in improving the horizon of the practice of urology in Nigeria. During the AGM of NAUS annual conference, Benin 2017, Dr. S. Osaghae was appointed as the new workshop committee chairman, a position he has held till date.
            </p>

            <h3 style={{ marginTop: '1.5rem', marginBottom: '1rem' }}>Constitution</h3>
            <p>
              In 2011, a new constitution of the association articulated by the Constitution Review Committee under the chairmanship of Prof J. C, Orakwe was adopted at the Annual General Meeting in Abuja. The adoption of the constitution brought about the expansion of the membership of the Executive Committee with the addition of the positions of the President-Elect, Assistant Secretary-General, Financial Secretary, Treasurer, and Ex-Officio members. The constitution was further reviewed by a committee constituted at the 26th AGM in Abuja (2021) and chaired by Prof. Nuhu K. Dakum. The revised constitution was adopted at the 27th AGM of the association held in Port Harcourt on Thursday, 24th November, 2022. Some of the amendments/additions were the adoption of the new name of the association, introduction of new positions PRO and Ex officios, welfare committee and its function, the expansion of membership types and their eligibility and status among other changes contained in the new adopted constitution.
            </p>

            <h3 style={{ marginTop: '1.5rem', marginBottom: '1rem' }}>Journal</h3>
            <p>
              The journal of the association, The Nigerian Journal of Urology (NJU), was inaugurated at the Abuja conference in 2011, with Prof. A. M. E. Nwofor as the pioneer editor, a position held until November 2025 when Prof. M. Ahmed was appointed as the new Editor-in-Chief. The journal became a fully digital, online Journal in April 2022; with an online manuscript management system and a journal website (<a href="https://nju.org.ng/index.php/nju" target="_blank" rel="noopener noreferrer" style={{ color: '#006400', fontWeight: 'bold', textDecoration: 'underline' }}>www.nju.org.ng</a>). All article submission and processing are now fully online and the journal is indexed in a number of repositories.
            </p>

            <h3 style={{ marginTop: '1.5rem', marginBottom: '1rem' }}>Website</h3>
            <p>
              The association has a functional website (<a href="https://nausurology.org" target="_blank" rel="noopener noreferrer" style={{ color: '#006400', fontWeight: 'bold', textDecoration: 'underline' }}>www.nausurology.org</a>).
            </p>

            <h3 style={{ marginTop: '1.5rem', marginBottom: '1rem' }}>Registration of the association</h3>
            <p>
              The association was registered with the Corporate Affairs Commission (CAC) ON 28th February, 2019 under a new name Association of Urological Surgeons, Nigeria (NAUS), with a registration number CAC/TT/N0 125351. The change from the previous name (Nigerian Association of Urological Surgeons (NAUS)) to the current one was occasioned by the new and stringent criteria for registration of new associations and organisations in Nigeria, in which only federal government owned organisations are permitted to begin their names with either “NIGERIAN” or “NATIONAL”.
            </p>

            <p>
              The association, which was inaugurated in 1992 with 10 members, now has over 270 members as at 2025.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;